@let user = userDetail();

<div class="address-container">
    <div class="address">
        <h2>{{ 'userAddressNational' | translate }}</h2>
        <p class="company">{{ location().company.name }}</p>
        <p>{{ user.orgCode }}</p>
        <p class="spacer">{{ user.nameNational }}</p>
        @if (location().address && location().address.building) {
            <div>
                <div>{{ location().address.building }}</div>
            </div>
        }
        @if (location().address) {
            <div>
                @if (location().address.floor) {
                    <span>{{ location().address.floor }}</span>
                }
                @if (location().address.suite && location().address.floor) {
                    <span>, </span>
                }
                @if (location().address.suite) {
                    <span>{{ location().address.suite }}</span>
                }
            </div>
        }
        @if (location().address.campus) {
            <div>
                <div>{{ location().address.campus }}</div>
            </div>
        }
        <p>{{ location().address.street }}</p>
        @if (location().address.postalCodeFirst) {
            <p>{{ location().address.postalCode }} {{ location().address.city }}</p>
        }
        @if (!location().address.postalCodeFirst) {
            <p>{{ location().address.city }} {{ location().address.postalCode }}</p>
        }
        <p>{{ location().country?.name }}</p>
    </div>
    <div class="address">
        <h2>{{ 'userAddressGlobal' | translate }}</h2>
        <p class="company">{{ location().company.name }}</p>
        <p>{{ user.orgCode }}</p>
        <p class="spacer">{{ user.name }}</p>
        @if (location().address && location().address.building) {
            <div>
                <div>{{ location().address.building }}</div>
            </div>
        }
        @if (location().address) {
            <div>
                @if (location().address.floor) {
                    <span>{{ location().address.floor }}</span>
                }
                @if (location().address.suite && location().address.floor) {
                    <span>, </span>
                }
                @if (location().address.suite) {
                    <span>{{ location().address.suite }}</span>
                }
            </div>
        }
        @if (location().address.campus) {
            <div>
                <div>{{ location().address.campus }}</div>
            </div>
        }
        <p>{{ location().address.street }}</p>
        @if (location().address.postalCodeFirst) {
            <p>{{ location().address.postalCode }} {{ location().address.city }}</p>
        }
        @if (!location().address.postalCodeFirst) {
            <p>{{ location().address.city }} {{ location().address.postalCode }}</p>
        }
        <p>{{ location().country?.isoName }}</p>
    </div>
    <div class="address">
        <h2>{{ 'userAddressInternalNational' | translate }}</h2>
        <p>{{ user.orgCode }}</p>
        <p>{{ location().locationCode }}</p>
        @if (user.building) {
            <p>{{ 'locationdata.buildingnamecolumn' | translate }}: {{ user.building }}</p>
        }
        @if (user.room) {
            <p>{{ 'locationdata.room' | translate }}: {{ user.room }}</p>
        }
        <p class="spacer-top">{{ user.nameNational }}</p>
    </div>
    <div class="address">
        <h2>{{ 'userAddressInternalGlobal' | translate }}</h2>
        <p>{{ user.orgCode }}</p>
        <p>{{ location().locationCode }}</p>
        @if (user.building) {
            <p>{{ 'locationdata.buildingnamecolumn' | translate }}: {{ user.building }}</p>
        }
        @if (user.room) {
            <p>{{ 'locationdata.room' | translate }}: {{ user.room }}</p>
        }
        <p class="spacer spacer-top">{{ user.name }}</p>
        <p>{{ location().country?.isoName }}</p>
    </div>
    <div style="clear: both"></div>
</div>
